import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import axios from 'lib/axios'
import React, { useState } from 'react'
import SubmissionHoursDropdown from './submit_application_package/SubmissionHoursDropdown'

export function SubmissionsReminderModal({ packageHashedId, scheduleByDay, propertyPageUrl }) {
  const [show, setShow] = useState(true)

  const postDismissal = async (temporary) => {
    try {
      await axios.post(`/packages/${packageHashedId}/dismiss_modal`, {
        dismissal_type: 'submission_reminder',
        ...(temporary && { temporary: true }),
      })
    } catch (e) {
      console.warn('SubmissionsReminderModal: failed to persist dismissal', e)
    }
  }

  const handleOk = () => {
    setShow(false)
    postDismissal(true)
  }

  const handleDoNotShowAgain = () => {
    setShow(false)
    postDismissal(false)
  }

  return (
    <Portal>
      <div className={clsx('new-beacon-modal', show && 'show')}>
        <div className="dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center">
          <div className="submissions-reminder-modal">
            <div className="submissions-reminder-modal__body dome-d-flex dome-flex-column dome-gap18">
              <div className="dome-d-flex dome-flex-column dome-gap12">
                <i className="fa-thin fa-clock submissions-reminder-modal__clock-icon" aria-hidden="true" />
                <span className="dome-h3 dome-color-dark-green">submissions reminder</span>
              </div>
              <div className="dome-d-flex dome-flex-column dome-gap12">
                <span className="dome-p1 dome-color-dark-grey">
                  Submissions are only accepted during regular business hours.
                </span>
                <SubmissionHoursDropdown scheduleByDay={scheduleByDay} propertyPageUrl={propertyPageUrl} />
              </div>
              <div className="dome-d-flex dome-justify-between dome-align-center">
                <button
                  type="button"
                  className="dome-btn dome-btn-link dome-btn-link-med-grey dome-d-flex dome-justify-between dome-align-center"
                  onClick={handleDoNotShowAgain}
                >
                  <i className="fa-light fa-xmark" aria-hidden="true" />
                  <span>do not show again</span>
                </button>
                <button type="button" className="dome-btn dome-btn-base dome-btn-grey-stroke" onClick={handleOk}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default SubmissionsReminderModal
